// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.general {
  overflow-x: hidden;
  overflow-y: hidden;
}

.logo {
  width: 150px;
  margin: 0 auto;
  display: block;
}

.footer {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 0;
}

.footer-txt {
  font-size: 0.7em;
}`, "",{"version":3,"sources":["webpack://./src/app/select-login/select-login.page.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,kBAAA;AACJ;;AACA;EACI,YAAA;EACA,cAAA;EACA,cAAA;AAEJ;;AACA;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAEJ;;AACA;EACI,gBAAA;AAEJ","sourcesContent":[".general {\n    overflow-x: hidden;\n    overflow-y: hidden;\n}\n.logo {\n    width: 150px;\n    margin: 0 auto;\n    display: block;\n}\n\n.footer {\n    width: 100%;\n    text-align: center;\n    position: absolute;\n    bottom: 0;\n}\n\n.footer-txt {\n    font-size: .7em;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
